import Alpine from "@alpinejs/csp";

export function initStore() {
  document.addEventListener("alpine:init", () => {
    Alpine.store("global", {
      // language topbar
      languageSet: localStorage.getItem("language-selected") ?? false,
      activeSiteLanguage: document
        .querySelector("html")
        .lang.split("-")[0]
        .toUpperCase(),
      showLangTopbar: false,

      // navigation
      navDropdownIsOpen: false,

      // country modal (legal)
      countryConfirmed:
        localStorage.getItem("non-us-person") ?? "not-confirmed",
      showLegalModal: false,
      showCtaModal: false,

      // page elements
      headerType:
        document.querySelector("[data-js-header]")?.dataset.jsHeader ?? false,
    });
  });
}
